import { render, staticRenderFns } from "./customer_sorting_pro.vue?vue&type=template&id=4b0e4c20&scoped=true&"
import script from "./customer_sorting_pro.vue?vue&type=script&lang=js&"
export * from "./customer_sorting_pro.vue?vue&type=script&lang=js&"
import style0 from "./customer_sorting_pro.vue?vue&type=style&index=0&id=4b0e4c20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e4c20",
  null
  
)

export default component.exports